import { FdeCdfSpecification } from 'features/dataLayers'
import {
  ApiCode,
  ForecastComponentConfig,
  GeckoAssetModel,
  GeckoComponentDataFrame,
  GeckoComponentModelType,
  GeckoTMinMethod,
} from 'types'

const TMIN_METHOD_MAP = {
  [GeckoTMinMethod.TMinByShellCourse.id]: GeckoTMinMethod.TMinByShellCourse,
  [GeckoTMinMethod.TMinByApi653.id]: GeckoTMinMethod.TMinByApi653,
  [GeckoTMinMethod.TMinByApi570.id]: GeckoTMinMethod.TMinByApi570,
  [GeckoTMinMethod.TMinWithAnnularRing.id]: GeckoTMinMethod.TMinWithAnnularRing,
  [GeckoTMinMethod.TMinByComponent.id]: GeckoTMinMethod.TMinByComponent,
  [GeckoTMinMethod.TMinByWall.id]: GeckoTMinMethod.TMinByWall,
  // Correct our bad Ids
  ['TMIN_BY_SHELL_COURSE']: GeckoTMinMethod.TMinByShellCourse,
  ['TMIN_BY_API_653']: GeckoTMinMethod.TMinByApi653,
}

/**
 * A callback that retrieves TMin Method according to the component status
 */
export function getTMinMethod(
  assetModel: GeckoAssetModel | undefined,
  componentId: string,
  selectedCDF: GeckoComponentDataFrame | undefined,
  forecastComponentConfig: ForecastComponentConfig | undefined
): GeckoTMinMethod | undefined {
  const selectedComponentModel = assetModel?.data.components.get(componentId)
  const tminMethodId = selectedCDF?.data.params.tmin_method?.id

  const apiCodeOverride = forecastComponentConfig?.api_code_override

  // TODO @choikh0423: Change this component_type check after setting up pipe component
  const canDoTminByApi653 =
    selectedComponentModel?.type ===
      GeckoComponentModelType.VerticalTankShell &&
    FdeCdfSpecification.TminByApi653.canCreateCdfData(
      assetModel,
      componentId,
      forecastComponentConfig ?? {}
    )

  const canDoTminWithAnnularRing =
    selectedComponentModel?.type === GeckoComponentModelType.TankFloor &&
    FdeCdfSpecification.TminWithAnnularRing.canCreateCdfData(
      assetModel,
      componentId,
      forecastComponentConfig ?? {}
    )

  const canDoTminByApi570 =
    (selectedComponentModel?.type === GeckoComponentModelType.PipeSection ||
      apiCodeOverride === ApiCode.Api570) &&
    FdeCdfSpecification.RlByApi570.canCreateCdfData(
      assetModel,
      componentId,
      forecastComponentConfig ?? {}
    )

  const canDoTminByShellCourse =
    FdeCdfSpecification.TminByShellCourse.canCreateCdfData(
      assetModel,
      componentId,
      forecastComponentConfig ?? {}
    )
  const canDoTminByComponent =
    FdeCdfSpecification.TminByComponent.canCreateCdfData(
      assetModel,
      componentId,
      forecastComponentConfig ?? {}
    )
  const canDoTMinByWall = FdeCdfSpecification.TminByWall.canCreateCdfData(
    assetModel,
    componentId,
    forecastComponentConfig ?? {}
  )

  return (
    (!!tminMethodId && TMIN_METHOD_MAP[tminMethodId]) ||
    (canDoTminByApi653
      ? GeckoTMinMethod.TMinByApi653
      : canDoTminByApi570
        ? GeckoTMinMethod.TMinByApi570
        : canDoTminWithAnnularRing
          ? GeckoTMinMethod.TMinWithAnnularRing
          : canDoTminByShellCourse
            ? GeckoTMinMethod.TMinByShellCourse
            : canDoTMinByWall
              ? GeckoTMinMethod.TMinByWall
              : canDoTminByComponent
                ? GeckoTMinMethod.TMinByComponent
                : undefined)
  )
}
